import cloudfrontLoader from 'utils/imageLoaders/cloudfrontLoader'

export function useImageLoader() {
  return cloudfrontLoader
}
